var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('account-dropdown',{attrs:{"selected-iban":_vm.selectedIban,"show-pending-count":""},on:{"onAccountChange":_vm.onAccountChange}})}
var staticRenderFns = []

export { render, staticRenderFns }